<template>
  <main class="flex-1 flex flex-col overflow-hidden">
    <Header :title="dataType == 'facebook' ? showLang[selectLang]['views']['List']['page_name'] : showLang[selectLang]['views']['List']['tiktok_page_name']" @childLang="useLang" @toggleSidebar="$emit('toggleSidebar')">
      <div class="d2-header-label">
        {{showTiktokLang[selectLang]['views']['List']['advertising_source']}}
      </div>
      <div class="mx-1">
        <Dropdown
          v-model="fromAccountSelect"
          optionLabel="name"
          optionValue="code"
          :options="fromAccountOptions"
          :placeholder="showLang[selectLang]['views']['List']['advertise_account_dropdown_placeholder']"
          appendTo="body"
          class="w-36 rounded-md"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
        >
          <template #value="slotProps">
            <div v-if="slotProps.value" class="flex align-items-center">
              <img v-if="slotProps.value == 'facebook'" :alt="slotProps.value" width="28" src="https://private.autoturn.net/img/facebook_icon.png"/>
              <img v-if="slotProps.value == 'tiktok'" class="mt-0.5 mr-0.5 mb-0.5" :alt="slotProps.value" width="25" src="https://private.autoturn.net/img/tiktok_icon.png"/>
              <div v-if="slotProps.value == 'facebook'" class="leading-7">Facebook</div>
              <div v-if="slotProps.value == 'tiktok'" class="leading-7">Tiktok</div>
            </div>
            <span v-else>
                {{ slotProps.placeholder }}
            </span>
          </template>
          <template #option="slotProps">
            <div class="flex align-items-center">
              <img v-if="slotProps.option.code == 'facebook'" class="-ml-0.5" :alt="slotProps.option.name" width="28" src="https://private.autoturn.net/img/facebook_icon.png"/>
              <img v-if="slotProps.option.code == 'tiktok'" class="mt-0.5 mr-0.5 mb-0.5" :alt="slotProps.option.name" width="25" src="https://private.autoturn.net/img/tiktok_icon.png"/>
              <div class="leading-7">{{ slotProps.option.name }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div v-if="dataType == 'facebook'" class="d2-header-label">
        {{showLang[selectLang]['views']['List']['advertise_account_text']}}
      </div>
      <div v-if="dataType == 'facebook'" class="mx-1">
        <Dropdown
          v-model="accountSelect"
          optionLabel="name"
          optionValue="code"
          :options="accountOptions"
          :placeholder="showLang[selectLang]['views']['List']['advertise_account_dropdown_placeholder']"
          appendTo="body"
          class="w-40 lg:w-52 rounded-md h-12 leading-8"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
          filter
          @change="campaign(accountSelect)"
        />
      </div>
      <div v-if="dataType == 'tiktok'" class="d2-header-label">
        {{showTiktokLang[selectLang]['views']['List']['account_name']}}
      </div>
      <div v-if="dataType == 'tiktok'" class="mx-1">
        <Dropdown
          v-model="accountSelect"
          optionLabel="name"
          optionValue="code"
          :options="accountOptions"
          :placeholder="showTiktokLang[selectLang]['views']['List']['advertise_account_dropdown_placeholder']"
          appendTo="body"
          class="w-40 lg:w-52 rounded-md h-12 leading-8"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
          filter
          @change="campaign(accountSelect)"
        />
      </div>
      <span class="d2-list-run-info">
        {{showLang[selectLang]['views']['List']['campaign_run_info']}}{{run_info}}
      </span>
    </Header>
    <section class="d2-list-toolbar">
      <button
        class="d2-list-btn-create"
        :class="{ 'ring-4 border-blue-400': nowStep === 10 || nowStep === 90 }"
        :style="nowStep == 10 || nowStep == 90 ? { zIndex: 100, position: 'relative' } : null"
        :disabled="isUes"
        @click="createCampaign()"
      >
        {{createText}}
      </button>
    </section>

    <!-- <section class="flex overflow-x-hidden bg-gray-200"> -->
    <section class="d2-list-main">
      <main id="edit_content" ref="scrollcontent" class="d2-list-content mx-auto overflow-y-scroll flex flex-row flex-wrap" style="height: 85vh;">
        <div v-if="dataType == 'facebook'" class="d2-list-charts-row">
          <EventsListChart v-bind:showChart="showChart" :title="`${showLang[selectLang]['views']['List']['events_list_chart_title']}`" :chartsData="lineStylesData" :guideStep="nowStep" />
          <EventsListWordcloud v-bind:showCloud="showCloud" v-bind:viewDatalist="keywordsList" v-bind:adaccountIdSelect="accountSelect" v-bind:lang="showLang[selectLang]" :guideStep="nowStep"/>
        </div>

        <div v-if="dataType == 'tiktok'" class="d2-list-charts-row">
          <TikTokEventsListChart v-bind:showChart="showChart" :title="`${showLang[selectLang]['views']['List']['tiktok_events_list_chart_title']}`" :chartsData="lineStylesData" :guideStep="nowStep" />
          <TikTokEventsListWordcloud v-bind:showCloud="showCloud" v-bind:viewDatalist="keywordsList" v-bind:adaccountIdSelect="accountSelect" v-bind:lang="showTiktokLang[selectLang]" :guideStep="nowStep"/>
        </div>

        <div v-if="dataType == 'facebook'" class="w-full flex flex-row flex-wrap items-start mt-3" :style="nowStep == 9 || nowStep == 90 ? { zIndex: 100, position: 'relative' } : null">
          <ListDataTable v-bind:showTable="showTable" v-bind:selecdedCurrency="selecdedCurrency" v-bind:viewDatalist="campaignListData" v-bind:fromAccountSelect="fromAccountSelect" v-bind:parentMemberInfo="memberInfo" v-bind:lang="showLang[selectLang]"/>
        </div>

        <div v-if="dataType == 'tiktok'" class="w-full flex flex-row flex-wrap items-start mt-3" :style="nowStep == 9 || nowStep == 90 ? { zIndex: 100, position: 'relative' } : null">
          <TikTokListDataTable v-bind:showTable="showTable" v-bind:selecdedCurrency="selecdedCurrency" v-bind:viewDatalist="campaignListData" v-bind:fromAccountSelect="fromAccountSelect" v-bind:parentMemberInfo="memberInfo" v-bind:lang="showTiktokLang[selectLang]"/>
        </div>
      </main>
    </section>
  </main>

  <div v-if="nowStep >= 7 && nowStep <= 9 || nowStep == 90" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0); z-index: 1100;"></div>

  <Mask :isDisplay="nowStep > -1" />
  <ListMask
    v-if="nowStep >= 7 && nowStep <= 10 || nowStep == 90"
    :nowStep="nowStep"
    :selectLang="selectLang"
    @nextStep="nextStep"
    @closeTips="closeTips"
    @closeForTeaching="doCloseForTeaching"
  />
</template>

<script>
import Mask from '@/components/Event/Mask.vue';
import ListMask from '@/components/Mask/ListMask.vue';

import Dropdown from 'primevue/dropdown'
import Header from '@/components/Header.vue'
import EventsListChart from '@/components/List/EventsListChart.vue'
import EventsListWordcloud from '@/components/List/EventsListWordcloud.vue'
import ListDataTable from '@/components/List/ListDataTable.vue'
import TikTokEventsListChart from '@/components/TikTokList/EventsListChart.vue'
import TikTokEventsListWordcloud from '@/components/TikTokList/EventsListWordcloud.vue'
import TikTokListDataTable from '@/components/TikTokList/ListDataTable.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import axios from 'axios'
import Qs from 'qs'
import lang from '@/language/lang.json'
import tiktokLang from '@/language/tiktok_lang.json'

// import { ref } from 'vue';

export default {
  name: 'List',
  components: {
    Mask,
    ListMask,
    Header,
    Dropdown,
    EventsListChart,
    EventsListWordcloud,
    ListDataTable,
    TikTokEventsListChart,
    TikTokEventsListWordcloud,
    TikTokListDataTable,
  },
  props: {
    getFirstLoginStatus: {
      type: Array
    },
    getTransmitFbNum: {
      type: String,
      default: ''
    },
    getTransmitTiktokNum: {
      type: String,
      default: ''
    },
  },
  setup() {

  },
  data() {
    return {
      selectLang: 'zh-TW',
      showLang: lang,
      showTiktokLang: tiktokLang,
      nowStep: -1,
      fromAccountSelect: 'facebook',
      // ========== 暫時隱藏 TikTok 選項（初始值）==========
      // 原選項: [{"name":"Facebook","code":"facebook"},{"name":"Tiktok","code":"tiktok"}]
      fromAccountOptions: [{"name":"Facebook","code":"facebook"}],
      // ========== 暫時隱藏 TikTok 選項結束 ==========
      dataType: 'facebook',
      accountSelect: '',
      accountOptions: [],
      selecdedCurrency: null,
      allLoading: true,
      showChart: false,
      showCloud: false,
      showTable: false,
      eventSelect: '',
      eventOptions: [],
      tableData: [],
      lineStylesData: {
        datasets: []
      },
      keywordsList: [],
      campaignListData: [],
      run_info: '-/-',
      createText: '請稍候...',
      isUes: true,
      member_source: 0,
      memberInfo: {
        status: 'y',
        plan_id: 1,
        source: 0,
      }
    }
  },
  created() {
    // console.log('created');

    let _tmp_params_id = this.$route.params.id;
    let _tmp_hash = _tmp_params_id.split("_");
    let hash = _tmp_hash[0];
    let link_type = _tmp_hash.pop();
    let routeType = this.$route.params.type;

    //console.log(_tmp_hash);
    //console.log(hash);
    //console.log(link_type);

    //console.log('router type');
    //console.log(routeType);

    if(routeType != '' && routeType != null && typeof routeType != 'undefined'){
      if(routeType == 't'){
        this.fromAccountSelect = 'tiktok';
        this.dataType = 'tiktok';
      }
    }

    if(hash != '' && hash != null && typeof hash != 'undefined'){
      axios
        .post('https://www.autoturn.net/api/member_info.php', Qs.stringify({
          s_code: hash,
        }), {withCredentials: true})
        .then((adResponse) => {
          // console.log('adResponse:'+adResponse.data.selecded_data);
          if(adResponse.data.status == 'success'){
            this.member_source = adResponse.data.return_data.source
            if(adResponse.data.return_data.first_login == 'Y'){
              this.nowStep = 7;
            }
            this.memberInfo = {
              status: adResponse.data.return_data.account_status,
              plan_id: adResponse.data.return_data.payment_plan_id,
              source: adResponse.data.return_data.source,
            };
            
            // ========== 暫時隱藏 TikTok 選項 ==========
            // 原邏輯：根據 fb_in_use_num 和 tiktok_in_use_num 決定選項
            /*
            if(adResponse.data.return_data.fb_in_use_num > 0 && adResponse.data.return_data.tiktok_in_use_num > 0){
              this.fromAccountOptions = [{"name":"Facebook","code":"facebook"},{"name":"Tiktok","code":"tiktok"}];
            }

            if(adResponse.data.return_data.fb_in_use_num > 0 && adResponse.data.return_data.tiktok_in_use_num == 0){
              this.fromAccountOptions = [{"name":"Facebook","code":"facebook"}];
            }

            if(adResponse.data.return_data.fb_in_use_num == 0 && adResponse.data.return_data.tiktok_in_use_num > 0){
              this.fromAccountOptions = [{"name":"Tiktok","code":"tiktok"}];

              this.fromAccountSelect = 'tiktok';
            }
            */

            // 新邏輯：只顯示 Facebook 選項
            if(adResponse.data.return_data.fb_in_use_num > 0){
              this.fromAccountOptions = [{"name":"Facebook","code":"facebook"}];
            }
            // ========== 暫時隱藏 TikTok 選項結束 ==========

            axios
              .post('https://www.autoturn.net/api/member_campaign_use_num.php', Qs.stringify({
                s_code: this.$route.params.id,
                typs: this.fromAccountSelect
              }))
              .then((response) => {
                // console.log('caResponse:'+caResponse.data.return_data);
                if(response.data.status == 'success'){
                  this.run_info = response.data.return_data
                }
              });

            if(this.fromAccountSelect == 'facebook'){
              //console.log('get fb');

              axios
                .post('https://www.autoturn.net/api/campaign_adaccounts.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: this.$route.params.adaccount_id,
                }))
                .then((adResponse) => {
                  // console.log('adResponse:'+adResponse.data.selecded_data);
                  if(adResponse.data.status == 'success'){
                    if(adResponse.data.return_data.length > 0){
                      //console.log('this.accountOptions');
                      //console.log(this.accountOptions);

                      this.accountOptions = adResponse.data.return_data
                      this.accountSelect = adResponse.data.selecded_data
                      this.selecdedCurrency =  adResponse.data.selecded_currency

                      this.createText = this.showLang[this.selectLang]['views']['List']['create_campaign_button_text'];
                      this.isUes = false;

                      if(this.dataType == 'tiktok'){
                        this.createText = this.showLang[this.selectLang]['views']['List']['create_tiktok_campaign_button_text'];
                      }

                      // console.log('created this.selecdedCurren:'+this.selecdedCurren);

                      // console.log('this.accountSelect');
                      // console.log(this.accountSelect);

                      axios
                        .post('https://www.autoturn.net/api/data/campaign_example_copy.php', Qs.stringify({
                          s_code: this.$route.params.id
                        }))
                        .then((response) => {
                          axios
                            .post('https://www.autoturn.net/api/campaign_list.php', Qs.stringify({
                              s_code: this.$route.params.id,
                              adaccount_id: this.accountSelect,
                            }))
                            .then((caResponse) => {
                              // console.log('caResponse:'+caResponse.data.return_data);
                              if(caResponse.data.status == 'success'){
                                this.campaignListData = caResponse.data.return_data
                              }

                              this.showTable = true;
                            });
                        });

                      // axios
                      //   .post('https://www.autoturn.net/api/campaign_list.php', Qs.stringify({
                      //     s_code: this.$route.params.id,
                      //     adaccount_id: adResponse.data.selecded_data,
                      //   }))
                      //   .then((caResponse) => {
                      //     // console.log('caResponse:'+caResponse.data.return_data);
                      //     if(caResponse.data.status == 'success'){
                      //       this.campaignListData = caResponse.data.return_data
                      //     }

                      //     this.showTable = true;
                      //   });

                      axios
                        .post('https://www.autoturn.net/api/campaign_lists_chart.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          adaccount_id: adResponse.data.selecded_data,
                        }))
                        .then((chResponse) => {
                          // console.log('chResponse.data');
                          // console.log(chResponse.data);
                          if(chResponse.data.status == 'success'){
                            this.lineStylesData = {
                              datasets: chResponse.data.return_data
                            }
                          }

                          this.showChart = true;
                        });

                      axios
                        .post('https://www.autoturn.net/api/campaign_lists_keyword.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          adaccount_id: adResponse.data.selecded_data,
                        }))
                        .then((keyResponse) => {
                          // console.log(keyResponse.data);
                          if(keyResponse.data.status == 'success'){
                            this.keywordsList = keyResponse.data.return_data
                          }

                          this.showCloud = true;
                        });
                    } else {
                      Swal.fire({
                        icon: 'error',
                        title: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['swal_title'],
                        text: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['swal_text'],
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['confirm_button']
                      }).then((result) => {
                        if (result.isConfirmed) {
                          window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                        } else if (result.isDenied) {
                          window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                        }
                      })
                    }
                  }
                });
            } else {
              //console.log('get tiktok');

              axios
                .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_adaccounts.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  advertiser_id: this.$route.params.adaccount_id,
                }))
                .then((adResponse) => {
                  // console.log('adResponse:'+adResponse.data.selecded_data);
                  if(adResponse.data.status == 'success'){
                    if(adResponse.data.return_data.length > 0){
                      this.accountOptions = adResponse.data.return_data
                      this.accountSelect = adResponse.data.selecded_data
                      this.selecdedCurrency =  adResponse.data.selecded_currency

                      this.createText = this.showLang[this.selectLang]['views']['List']['create_campaign_button_text'];
                      this.isUes = false;

                      if(this.dataType == 'tiktok'){
                        this.createText = this.showLang[this.selectLang]['views']['List']['create_tiktok_campaign_button_text'];
                      }

                      axios
                        .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_list.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          advertiser_id: this.accountSelect,
                        }))
                        .then((caResponse) => {
                          // console.log('caResponse:'+caResponse.data.return_data);
                          if(caResponse.data.status == 'success'){
                            this.campaignListData = caResponse.data.return_data
                          }

                          this.showTable = true;
                        });

                      axios
                        .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_lists_chart.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          advertiser_id: adResponse.data.selecded_data,
                        }))
                        .then((chResponse) => {
                          // console.log('chResponse.data');
                          // console.log(chResponse.data);
                          if(chResponse.data.status == 'success'){
                            this.lineStylesData = {
                              datasets: chResponse.data.return_data
                            }
                          }

                          this.showChart = true;
                        });

                      axios
                        .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_lists_keyword.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          advertiser_id: adResponse.data.selecded_data,
                        }))
                        .then((keyResponse) => {
                          // console.log(keyResponse.data);
                          if(keyResponse.data.status == 'success'){
                            this.keywordsList = keyResponse.data.return_data
                          }

                          this.showCloud = true;
                        });
                    } else {
                      Swal.fire({
                        icon: 'error',
                        title: this.showLang[this.selectLang]['views']['List']['created']['axios']['tiktok_success_else']['swal_title'],
                        text: this.showLang[this.selectLang]['views']['List']['created']['axios']['tiktok_success_else']['swal_text'],
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['axios']['tiktok_success_else']['confirm_button']
                      }).then((result) => {
                        if (result.isConfirmed) {
                          window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                        } else if (result.isDenied) {
                          window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                        }
                      })
                    }
                  }
                });
            }
          } else {
            Swal.fire({
              icon: 'error',
              title: this.showLang[this.selectLang]['views']['List']['created']['else']['swal_title'],
              text: adResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['else']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                // Swal.fire('Saved!', '', 'success')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              } else if (result.isDenied) {
                // Swal.fire('Changes are not saved', '', 'info')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              }
            })
          }
        });


    } else {
      Swal.fire({
        icon: 'error',
        title: this.showLang[this.selectLang]['views']['List']['created']['else']['swal_title'],
        text: this.showLang[this.selectLang]['views']['List']['created']['else']['swal_text'],
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['else']['confirm_button']
        // denyButtonText: `Don't save`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          // Swal.fire('Saved!', '', 'success')
          // this.allPageLoading = true
          window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
        } else if (result.isDenied) {
          // Swal.fire('Changes are not saved', '', 'info')
          // this.allPageLoading = true
          window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
        }
      })
    }
  },
  watch:{
    'getFirstLoginStatus': function(v){
      //console.log('watch getFirstLoginStatus');
      //console.log(v);
      if(v.data.return_data.first_login != '' && v.data.return_data.first_login != null && typeof v.data.return_data.first_login != undefined){
        if(v.data.return_data.first_login == 'Y'){
          axios
            .post('https://www.autoturn.net/api/data/campaign_example_copy.php', Qs.stringify({
              s_code: this.$route.params.id
            }))
            .then((response) => {
              axios
                .post('https://www.autoturn.net/api/campaign_list.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: this.accountSelect,
                }))
                .then((caResponse) => {
                  // console.log('caResponse:'+caResponse.data.return_data);
                  if(caResponse.data.status == 'success'){
                    this.campaignListData = caResponse.data.return_data
                  }
                });
            });

          this.nowStep = 7;
        }
      }
    },
    fromAccountSelect(v){
      //console.log('fromAccountSelect');
      //console.log(v);

      this.dataType = v

      let hash = this.$route.params.id;

      let routeType = 'f';
      document.title = this.showLang[this.selectLang]['views']['List']['page_name']+' - AutoTurn';
      if(v == 'tiktok'){
        routeType = 't';
        document.title = this.showLang[this.selectLang]['views']['List']['tiktok_page_name']+' - AutoTurn';
      }

      this.$router.push({ params: { type: routeType }});

      if(hash != '' && hash != null && typeof hash != 'undefined'){
        //console.log('props this.getFirstLoginStatusData');
        //console.log(this.getFirstLoginStatusData);

        axios
          .post('https://www.autoturn.net/api/member_campaign_use_num.php', Qs.stringify({
            s_code: hash,
            type: v
          }))
          .then((response) => {
            // console.log('caResponse:'+caResponse.data.return_data);
            if(response.data.status == 'success'){
              this.run_info = response.data.return_data
            }
          });

        if(v == 'facebook'){
          axios
            .post('https://www.autoturn.net/api/campaign_adaccounts.php', Qs.stringify({
              s_code: hash,
              adaccount_id: this.$route.params.adaccount_id,
            }))
            .then((adResponse) => {
              // console.log('adResponse:'+adResponse.data.selecded_data);
              if(adResponse.data.status == 'success'){
                if(adResponse.data.return_data.length > 0){
                  this.accountOptions = adResponse.data.return_data
                  this.accountSelect = adResponse.data.selecded_data
                  this.selecdedCurrency =  adResponse.data.selecded_currency

                  //console.log('list campaign_adaccounts this.selecdedCurrency');
                  //console.log(this.selecdedCurrency);

                  this.createText = this.showLang[this.selectLang]['views']['List']['create_campaign_button_text'];
                  this.isUes = false;

                  if(this.dataType == 'tiktok'){
                    this.createText = this.showLang[this.selectLang]['views']['List']['create_tiktok_campaign_button_text'];
                  }

                  axios
                    .post('https://www.autoturn.net/api/campaign_list.php', Qs.stringify({
                      s_code: hash,
                      adaccount_id: adResponse.data.selecded_data,
                    }))
                    .then((caResponse) => {
                      // console.log('caResponse:'+caResponse.data.return_data);
                      if(caResponse.data.status == 'success'){
                        this.campaignListData = caResponse.data.return_data
                      }

                      this.showTable = true;
                    });

                  axios
                    .post('https://www.autoturn.net/api/campaign_lists_chart.php', Qs.stringify({
                      s_code: hash,
                      adaccount_id: adResponse.data.selecded_data,
                    }))
                    .then((chResponse) => {
                      // console.log('chResponse.data');
                      // console.log(chResponse.data);
                      if(chResponse.data.status == 'success'){
                        this.lineStylesData = {
                          datasets: chResponse.data.return_data
                        }
                      }

                      this.showChart = true;
                    });

                  axios
                    .post('https://www.autoturn.net/api/campaign_lists_keyword.php', Qs.stringify({
                      s_code: hash,
                      adaccount_id: adResponse.data.selecded_data,
                    }))
                    .then((keyResponse) => {
                      // console.log(keyResponse.data);
                      if(keyResponse.data.status == 'success'){
                        this.keywordsList = keyResponse.data.return_data
                      }

                      this.showCloud = true;
                    });
                } else {
                  Swal.fire({
                    icon: 'error',
                    title: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['swal_title'],
                    text: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['swal_text'],
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['confirm_button']
                  }).then((result) => {
                    if (result.isConfirmed) {
                      window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                    } else if (result.isDenied) {
                      window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                    }
                  })
                }
              }
            });
        } else {
          axios
            .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_adaccounts.php', Qs.stringify({
              s_code: hash,
              advertiser_id: this.$route.params.adaccount_id,
            }))
            .then((adResponse) => {
              // console.log('adResponse:'+adResponse.data.selecded_data);
              if(adResponse.data.status == 'success'){
                if(adResponse.data.return_data.length > 0){
                  this.accountOptions = adResponse.data.return_data
                  this.accountSelect = adResponse.data.selecded_data
                  this.selecdedCurrency =  adResponse.data.selecded_currency

                  //console.log('list tiktok_campaign_adaccounts this.selecdedCurrency');
                  //console.log(this.selecdedCurrency);

                  this.createText = this.showLang[this.selectLang]['views']['List']['create_campaign_button_text'];
                  this.isUes = false;

                  if(this.dataType == 'tiktok'){
                    this.createText = this.showLang[this.selectLang]['views']['List']['create_tiktok_campaign_button_text'];
                  }

                  axios
                    .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_list.php', Qs.stringify({
                      s_code: hash,
                      advertiser_id: this.accountSelect,
                    }))
                    .then((caResponse) => {
                      // console.log('caResponse:'+caResponse.data.return_data);
                      if(caResponse.data.status == 'success'){
                        this.campaignListData = caResponse.data.return_data
                      }

                      this.showTable = true;
                    });

                  axios
                    .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_lists_chart.php', Qs.stringify({
                      s_code: hash,
                      advertiser_id: adResponse.data.selecded_data,
                    }))
                    .then((chResponse) => {
                      // console.log('chResponse.data');
                      // console.log(chResponse.data);
                      if(chResponse.data.status == 'success'){
                        this.lineStylesData = {
                          datasets: chResponse.data.return_data
                        }
                      }

                      this.showChart = true;
                    });

                  axios
                    .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_lists_keyword.php', Qs.stringify({
                      s_code: hash,
                      advertiser_id: adResponse.data.selecded_data,
                    }))
                    .then((keyResponse) => {
                      // console.log(keyResponse.data);
                      if(keyResponse.data.status == 'success'){
                        this.keywordsList = keyResponse.data.return_data
                      }

                      this.showCloud = true;
                    });
                }
              }
            });
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: this.showLang[this.selectLang]['views']['List']['created']['else']['swal_title'],
          text: this.showLang[this.selectLang]['views']['List']['created']['else']['swal_text'],
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['else']['confirm_button']
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            // Swal.fire('Saved!', '', 'success')
            // this.allPageLoading = true
            window.location.href = "https://www.autoturn.net/inside/index.php/index/logout?o=1";
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            // this.allPageLoading = true
            window.location.href = "https://www.autoturn.net/inside/index.php/index/logout?o=1";
          }
        })
      }
    }
  },
  methods: {
    useLang(v){
      if(v == '' || v == null || typeof v == 'undefined'){
        v = 'zh-TW';
      }

      this.selectLang = v

      this.$emit('childLang', v);

      document.title = this.showLang[this.selectLang]['views']['List']['page_name']+' - AutoTurn';
      if(this.dataType == 'tiktok'){
        document.title = this.showLang[this.selectLang]['views']['List']['tiktok_page_name']+' - AutoTurn';
      }
    },
    onCancel(){
      // console.log('onCancel');
      this.allLoading = false;
    },
    campaign(value){
      // console.log('campaign:'+value);
      this.showChart = false;
      this.showCloud = false;
      this.showTable = false;

      if(this.fromAccountSelect == 'facebook'){
        axios
          .post('https://www.autoturn.net/api/campaign_adaccounts.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: value,
          }))
          .then((adResponse) => {
            if(adResponse.data.status == 'success'){
              this.selecdedCurrency =  adResponse.data.selecded_currency
            }
          });

        axios
          .post('https://www.autoturn.net/api/campaign_list.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: value,
          }))
          .then((caResponse) => {
            // console.log(caResponse.data);
            if(caResponse.data.status == 'success'){
              this.campaignListData = caResponse.data.return_data
            }

            this.showTable = true;
          });

        axios
          .post('https://www.autoturn.net/api/campaign_lists_chart.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: value,
          }))
          .then((chResponse) => {
            // console.log('chResponse.data');
            // console.log(chResponse.data);
            if(chResponse.data.status == 'success'){
              this.lineStylesData = {
                datasets: chResponse.data.return_data
              }
            }

            this.showChart = true;
          });

        axios
          .post('https://www.autoturn.net/api/campaign_lists_keyword.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: value,
          }))
          .then((keyResponse) => {
            // console.log(keyResponse.data);
            if(keyResponse.data.status == 'success'){
              this.keywordsList = [];
              this.keywordsList = keyResponse.data.return_data

              // console.log('this.keywordsList');
              // console.log(this.keywordsList);
            }

            this.showCloud = true;
          });
      } else {
        axios
          .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_adaccounts.php', Qs.stringify({
            s_code: this.$route.params.id,
            advertiser_id: value,
          }))
          .then((adResponse) => {
            // console.log('adResponse:'+adResponse.data.selecded_data);
            if(adResponse.data.status == 'success'){
              if(adResponse.data.return_data.length > 0){
                // this.accountOptions = adResponse.data.return_data
                // this.accountSelect = adResponse.data.selecded_data
                this.selecdedCurrency =  adResponse.data.selecded_currency

                // this.createText = this.showLang[this.selectLang]['views']['List']['create_campaign_button_text'];
                // this.isUes = false;

                axios
                  .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_list.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    advertiser_id: value,
                  }))
                  .then((caResponse) => {
                    // console.log('caResponse:'+caResponse.data.return_data);
                    if(caResponse.data.status == 'success'){
                      this.campaignListData = caResponse.data.return_data
                    }

                    this.showTable = true;
                  });

                axios
                  .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_lists_chart.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    advertiser_id: value,
                  }))
                  .then((chResponse) => {
                    // console.log('chResponse.data');
                    // console.log(chResponse.data);
                    if(chResponse.data.status == 'success'){
                      this.lineStylesData = {
                        datasets: chResponse.data.return_data
                      }
                    }

                    this.showChart = true;
                  });

                axios
                  .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_lists_keyword.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    advertiser_id: value,
                  }))
                  .then((keyResponse) => {
                    // console.log(keyResponse.data);
                    if(keyResponse.data.status == 'success'){
                      this.keywordsList = keyResponse.data.return_data
                    }

                    this.showCloud = true;
                  });
              }
            }
          });
      }
    },
    createCampaign(){
      let member_hash = this.$route.params.id
      let type = this.$route.params.type
      let adaccount_id = this.$route.params.adaccount_id

      axios
        .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
          s_code: member_hash,
          route_type: type,
          active: 'add',
        }))
        .then((caResponse) => {

          if(caResponse.data.status == 'error'){
            if(caResponse.data.type == 2){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/events-list/"+type+"/"+member_hash+"/"+this.accountSelect;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/events-list/"+type+"/"+member_hash+"/"+this.accountSelect;
                }
              })
            } else if(caResponse.data.type == 3){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/"+type+"/"+member_hash;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/"+type+"/"+member_hash;
                }
              })
            } else {
              Swal.fire(
                        this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['swal_title'],
                        caResponse.data.info,
                        caResponse.data.status
                      )
            }
          }

          if(caResponse.data.status == 'warning'){
            Swal.fire({
              icon: 'warning',
              title: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['warning']['swal_title'],
              text: caResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['warning']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              axios
                .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  status: 'N',
                }))
                .then((adResponse) => {
                  if(this.fromAccountSelect == 'facebook'){
                    window.location.href = "https://private.autoturn.net/event-add/"+type+"/"+member_hash+"/"+this.accountSelect;
                  } else {
                    window.location.href = "https://private.autoturn.net/event-add-tiktok/"+type+"/"+member_hash+"/"+this.accountSelect;
                  }
                });
            });
          }

          if(caResponse.data.status == 'success'){
            axios
              .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
                s_code: this.$route.params.id,
                status: 'N',
              }))
              .then((adResponse) => {
                if(this.fromAccountSelect == 'facebook'){
                  window.location.href = "https://private.autoturn.net/event-add/"+type+"/"+member_hash+"/"+this.accountSelect;
                } else {
                  window.location.href = "https://private.autoturn.net/event-add-tiktok/"+type+"/"+member_hash+"/"+this.accountSelect;
                }
              });
          }

          if(caResponse.data.status == 'login'){
            Swal.fire({
              icon: 'error',
              title: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['login']['swal_title'],
              text: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['login']['swal_text'],
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['login']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                // Swal.fire('Saved!', '', 'success')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              } else if (result.isDenied) {
                // Swal.fire('Changes are not saved', '', 'info')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              }
            })
          }
        });
    },
    nextStep() {
      this.nowStep = this.nowStep + 1;      
      //console.log('list this.nextStep');
      //console.log(this.nowStep);

      if(this.nowStep == 9 && this.member_source == 6){
        this.nowStep = 90;

        this.$refs.scrollcontent.scrollTo({
          top: 500,
          behavior: 'smooth'
        });
      } else if(this.nowStep == 9){
        this.$refs.scrollcontent.scrollTo({
          top: 500,
          behavior: 'smooth'
        });
      } else if(this.nowStep == 10) {
        this.$refs.scrollcontent.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    closeTips() {
      this.nowStep = -1;
      //console.log('closeTips');
      //console.log(this.nowStep);

      axios
        .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
          s_code: this.$route.params.id,
          status: 'N',
        }))
        .then((adResponse) => {});
    },
    getTransmitTiktokNum(v){
      //console.log('watch getTransmitTiktokNum');
      //console.log(v);
      //console.log(this.transmitTiktokNum);
      this.transmitTiktokNum = v;
      //console.log(this.transmitTiktokNum);
    },
    doCloseForTeaching(){
      //console.log('list doCloseForTeaching');
      this.nowStep = -1;

      axios
        .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
          s_code: this.$route.params.id,
          status: 'N',
        }))
        .then((adResponse) => {});
    }
  },
  mounted () {
    // document.title = '行銷活動列表 - AutoTurn';
  },
  computed: {
    getFirstLoginStatusData: {
      get: function () {
        return this.getFirstLoginStatus
      },
      set: function (value) {
        this.$emit('update:getFirstLoginStatusData', value)
      },
    },
  }
}

</script>

<style lang="scss" scoped>

</style>